import { faEnvelope, faPhone } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePhoneFormat } from 'hooks/usePhoneFormat';
import React from 'react';

import classes from './ClientInfoCard.module.scss';

interface ClientInfoCardProps {
    clientName: string;
    clientPhone?: string;
    clientEmail?: string;
}

export const ClientInfoCard: React.FC<ClientInfoCardProps> = props => {
    const formattedPhone = usePhoneFormat(props.clientPhone || '');

    return (
        <div className={classes.root}>
            <h1 className="h2 underlined w-full">Welcome back</h1>

            <div className={classes.info}>
                <div className={classes.name}>{props.clientName}</div>

                {props.clientPhone && (
                    <div className={classes.contact}>
                        <FontAwesomeIcon icon={faPhone} className={classes.icon} />
                        <span>{formattedPhone}</span>
                    </div>
                )}

                {props.clientEmail && (
                    <div className={classes.contact}>
                        <FontAwesomeIcon icon={faEnvelope} className={classes.icon} />
                        <span>{props.clientEmail}</span>
                    </div>
                )}
            </div>
        </div>
    );
};
